// extracted by mini-css-extract-plugin
export default {"main_container":"Price_main_container__MP9DJ","spoiler":"Price_spoiler__miozC","title":"Price_title__vrOO4","sub_title":"Price_sub_title__wfLig"};